import "./blogContainer.css";
import { useState, useEffect } from 'react';
import Footer from "../footer/Footer";
// import { blogdata } from "../../data";
import dateFormat from 'dateformat';
import IMAGES from "../../images/images";

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import Loader from "../../subComponents/loader/Loader";



export default function BlogContainer() {
    const rss2json =  "https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@Omotola_";
    const [myBlog, setMyBlog] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [blogPosts, setBlogPosts] = useState([]);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const filteredData = myBlog.filter((project) =>
        project.title.toLowerCase().includes(searchTerm.toLowerCase())
        );

        setBlogPosts(filteredData);
    }, [searchTerm, myBlog]);

    useEffect(() => {
        // setLoading(true);
        fetch(rss2json)
            .then(res => res.json())
            .then(data => {
                
                setMyBlog(data.items)
                // console.log(data.items)
                setLoading(false);
            })
    }, [rss2json]);

    // console.log("posts>>", myBlog.items[0].title);

    return (

        <div className="blog">
            <div className="blog__top">
                <h2>Blog Posts</h2>
                <div className="blog__titleSearch">
                        <div className="blog__input">
                            <img src={IMAGES.search_icon} alt="" />
                            <input type="text" placeholder="find blog article..." onChange={(e) => setSearchTerm(e.target.value)} />
                        </div>
                </div>
            </div>
                {!loading? 
            <section className="blogWrapper">
                
                { blogPosts.length ? blogPosts.map((d) => (
                        <a href={d.link} target='_blank' rel='noopener noreferrer'>
                            <div className="blog__card">
                                <div className="blog__imgWrapper">
                                    <img src={d.thumbnail} alt={d.title} />
                                </div>
                                <div className="blog__text">
                                    <h3>{d.title}</h3>
                                    <ul className="blog__categories">
                                        {d.categories.map((c) => (
                                            <li># {c}</li>
                                        ))}
                                    </ul>
                                    <span className="blog__date">
                                        {dateFormat((d.pubDate), "mmmm dS, yyyy")}
                                    </span>
                                </div>
                            </div>
                        </a>
                    )) : <p className="blog__noResult">Oops,try again. There isn't such article...</p>}
                    
                
            
            </section>
            : <Loader /> }  
            <Footer />
        </div>
    )
}
